<template>
    <Loader v-if="loading" />
    <div style="padding: 1rem;">

        <div class="space-y-2">
            <h2 class="font-semibold text-center">Flussi Ore</h2>
        </div>

        <div class="flex flex-column md:flex-row md:align-items-start gap-3 mb-3">
            <div class="flex flex-column gap-2 w-full">

                <span class="p-input-icon-left w-full mt-2 md:w-6 md:mt-0">
                    <i class="pi pi-search" />
                    <InputText v-model="searchPod" placeholder="Cerca POD" class="w-full" @keyup.enter="onSearch" />
                </span>

                <div class="flex flex-column w-full md:w-6 md:mt-0">
                    <label for="dataMisura" class="font-medium mb-2 mt-4 ">Data Misura:</label>
                    <Calendar
                    v-model="dataMisura"
                    view="month"
                    showIcon
                    dateFormat="mm/yy"
                    placeholder="Seleziona una data"    
                    class="w-full"
                    inputId="dataMisura"
                    />
                </div>
                        
                <div class="pt-4 mb-4" >
                    <Button label="Cerca" icon="pi pi-search" @click="onSearch"/>
                </div>
            </div>
        </div>

        <Card>
            <template #title>Consumi per ore</template>
            <template #content>
                <div v-if="flussiOre?.length">
                    <DataTable :value="flussiOre" lazy :paginator="true" :rows="rows" :totalRecords="totalRecords"
                        :first="(currentPage - 1) * rows" @page="onPage" @sort="onSort" stripedRows
                        responsiveLayout="scroll" class="lv-data-table">
                        <Column field="pod" header="POD" sortable />
                        <Column field="data_misura" header="Data" sortable />
                        <!-- Colonne EA -->
                        <Column field="ea1" header="EA 00:00-01:00" sortable><template #body="{ data }">{{ formatNumber(data.ea1) }}</template></Column>
                        <Column field="ea2" header="EA 01:00-02:00" sortable><template #body="{ data }">{{ formatNumber(data.ea2) }}</template></Column>
                        <Column field="ea3" header="EA 02:00-03:00" sortable><template #body="{ data }">{{ formatNumber(data.ea3) }}</template></Column>
                        <Column field="ea4" header="EA 03:00-04:00" sortable><template #body="{ data }">{{ formatNumber(data.ea4) }}</template></Column>
                        <Column field="ea5" header="EA 04:00-05:00" sortable><template #body="{ data }">{{ formatNumber(data.ea5) }}</template></Column>
                        <Column field="ea6" header="EA 05:00-06:00" sortable><template #body="{ data }">{{ formatNumber(data.ea6) }}</template></Column>
                        <Column field="ea7" header="EA 06:00-07:00" sortable><template #body="{ data }">{{ formatNumber(data.ea7) }}</template></Column>
                        <Column field="ea8" header="EA 07:00-08:00" sortable><template #body="{ data }">{{ formatNumber(data.ea8) }}</template></Column>
                        <Column field="ea9" header="EA 08:00-09:00" sortable><template #body="{ data }">{{ formatNumber(data.ea9) }}</template></Column>
                        <Column field="ea10" header="EA 09:00-10:00" sortable><template #body="{ data }">{{ formatNumber(data.ea10) }}</template></Column>
                        <Column field="ea11" header="EA 10:00-11:00" sortable><template #body="{ data }">{{ formatNumber(data.ea11) }}</template></Column>
                        <Column field="ea12" header="EA 11:00-12:00" sortable><template #body="{ data }">{{ formatNumber(data.ea12) }}</template></Column>
                        <Column field="ea13" header="EA 12:00-13:00" sortable><template #body="{ data }">{{ formatNumber(data.ea13) }}</template></Column>
                        <Column field="ea14" header="EA 13:00-14:00" sortable><template #body="{ data }">{{ formatNumber(data.ea14) }}</template></Column>
                        <Column field="ea15" header="EA 14:00-15:00" sortable><template #body="{ data }">{{ formatNumber(data.ea15) }}</template></Column>
                        <Column field="ea16" header="EA 15:00-16:00" sortable><template #body="{ data }">{{ formatNumber(data.ea16) }}</template></Column>
                        <Column field="ea17" header="EA 16:00-17:00" sortable><template #body="{ data }">{{ formatNumber(data.ea17) }}</template></Column>
                        <Column field="ea18" header="EA 17:00-18:00" sortable><template #body="{ data }">{{ formatNumber(data.ea18) }}</template></Column>
                        <Column field="ea19" header="EA 18:00-19:00" sortable><template #body="{ data }">{{ formatNumber(data.ea19) }}</template></Column>
                        <Column field="ea20" header="EA 19:00-20:00" sortable><template #body="{ data }">{{ formatNumber(data.ea20) }}</template></Column>
                        <Column field="ea21" header="EA 20:00-21:00" sortable><template #body="{ data }">{{ formatNumber(data.ea21) }}</template></Column>
                        <Column field="ea22" header="EA 21:00-22:00" sortable><template #body="{ data }">{{ formatNumber(data.ea22) }}</template></Column>
                        <Column field="ea23" header="EA 22:00-23:00" sortable><template #body="{ data }">{{ formatNumber(data.ea23) }}</template></Column>
                        <Column field="ea24" header="EA 23:00-00:00" sortable><template #body="{ data }">{{ formatNumber(data.ea24) }}</template></Column>

                        <!-- Colonne ER -->
                        <Column field="er1" header="ER 00:00-01:00" sortable><template #body="{ data }">{{ formatNumber(data.er1) }}</template></Column>
                        <Column field="er2" header="ER 01:00-02:00" sortable><template #body="{ data }">{{ formatNumber(data.er2) }}</template></Column>
                        <Column field="er3" header="ER 02:00-03:00" sortable><template #body="{ data }">{{ formatNumber(data.er3) }}</template></Column>
                        <Column field="er4" header="ER 03:00-04:00" sortable><template #body="{ data }">{{ formatNumber(data.er4) }}</template></Column>
                        <Column field="er5" header="ER 04:00-05:00" sortable><template #body="{ data }">{{ formatNumber(data.er5) }}</template></Column>
                        <Column field="er6" header="ER 05:00-06:00" sortable><template #body="{ data }">{{ formatNumber(data.er6) }}</template></Column>
                        <Column field="er7" header="ER 06:00-07:00" sortable><template #body="{ data }">{{ formatNumber(data.er7) }}</template></Column>
                        <Column field="er8" header="ER 07:00-08:00" sortable><template #body="{ data }">{{ formatNumber(data.er8) }}</template></Column>
                        <Column field="er9" header="ER 08:00-09:00" sortable><template #body="{ data }">{{ formatNumber(data.er9) }}</template></Column>
                        <Column field="er10" header="ER 09:00-10:00" sortable><template #body="{ data }">{{ formatNumber(data.er10) }}</template></Column>
                        <Column field="er11" header="ER 10:00-11:00" sortable><template #body="{ data }">{{ formatNumber(data.er11) }}</template></Column>
                        <Column field="er12" header="ER 11:00-12:00" sortable><template #body="{ data }">{{ formatNumber(data.er12) }}</template></Column>
                        <Column field="er13" header="ER 12:00-13:00" sortable><template #body="{ data }">{{ formatNumber(data.er13) }}</template></Column>
                        <Column field="er14" header="ER 13:00-14:00" sortable><template #body="{ data }">{{ formatNumber(data.er14) }}</template></Column>
                        <Column field="er15" header="ER 14:00-15:00" sortable><template #body="{ data }">{{ formatNumber(data.er15) }}</template></Column>
                        <Column field="er16" header="ER 15:00-16:00" sortable><template #body="{ data }">{{ formatNumber(data.er16) }}</template></Column>
                        <Column field="er17" header="ER 16:00-17:00" sortable><template #body="{ data }">{{ formatNumber(data.er17) }}</template></Column>
                        <Column field="er18" header="ER 17:00-18:00" sortable><template #body="{ data }">{{ formatNumber(data.er18) }}</template></Column>
                        <Column field="er19" header="ER 18:00-19:00" sortable><template #body="{ data }">{{ formatNumber(data.er19) }}</template></Column>
                        <Column field="er20" header="ER 19:00-20:00" sortable><template #body="{ data }">{{ formatNumber(data.er20) }}</template></Column>
                        <Column field="er21" header="ER 20:00-21:00" sortable><template #body="{ data }">{{ formatNumber(data.er21) }}</template></Column>
                        <Column field="er22" header="ER 21:00-22:00" sortable><template #body="{ data }">{{ formatNumber(data.er22) }}</template></Column>
                        <Column field="er23" header="ER 22:00-23:00" sortable><template #body="{ data }">{{ formatNumber(data.er23) }}</template></Column>
                        <Column field="er24" header="ER 23:00-00:00" sortable><template #body="{ data }">{{ formatNumber(data.er24) }}</template></Column>

                        <template #footer>
                            <div class="w-full overflow-auto">
                                <table class="w-full text-sm">
                                <thead>
                                    <tr>
                                    <th class="text-left">EAF1</th>
                                    <th class="text-left">EAF2</th>
                                    <th class="text-left">EAF3</th>
                                    <th class="text-left">ERF1</th>
                                    <th class="text-left">ERF2</th>
                                    <th class="text-left">ERF3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>{{ formatNumber(totaliFooter.eaf1) }}</td>
                                    <td>{{ formatNumber(totaliFooter.eaf2) }}</td>
                                    <td>{{ formatNumber(totaliFooter.eaf3) }}</td>
                                    <td>{{ formatNumber(totaliFooter.erf1) }}</td>
                                    <td>{{ formatNumber(totaliFooter.erf2) }}</td>
                                    <td>{{ formatNumber(totaliFooter.erf3) }}</td>
                                    </tr>
                                </tbody>
                                </table>

                                <table class="w-full text-sm">
                                    <tbody>
                                        <tr>
                                            <td colspan="50" class="text-right pr-4 pt-2 border-top-1 surface-border">
                                                Totale record: {{ totalRecords }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>

                    </DataTable>
                </div>
                <div v-else>Tabella vuota. Cerca per POD e Data.</div>
            </template>
        </Card>

        <Card v-if="dataMisuraConvertita" class="mt-5">
            <template #title>Letture del {{ dataMisuraConvertita }} </template>
            <template #content>
                <div v-if="letture.length > 0">
                    <DataTable :value="letture" responsiveLayout="scroll" class="lv-data-table">

                        <Column field="pod" header="POD" sortable />
                        <Column field="data_misura" header="Data Misura" sortable />
                        <Column field="data_comunicazione" header="Data Comunicazione" sortable />
                        <Column field="type" header="Tipo" sortable />
                        <Column field="eaf1" header="EAF1" sortable />
                        <Column field="eaf2" header="EAF2" sortable />
                        <Column field="eaf3" header="EAF3" sortable />
                        <Column field="erf1" header="ERF1" sortable />
                        <Column field="erf2" header="ERF2" sortable />
                        <Column field="erf3" header="ERF3" sortable />
                        <Column field="pf1" header="PF1" sortable />
                        <Column field="pf2" header="PF2" sortable />
                        <Column field="pf3" header="PF3" sortable />

                        <template #footer>
                            <div class="w-full overflow-auto">
                                <table class="w-full text-sm">
                                <thead>
                                    <tr>
                                    <th class="text-left">EAF1</th>
                                    <th class="text-left">EAF2</th>
                                    <th class="text-left">EAF3</th>
                                    <th class="text-left">ERF1</th>
                                    <th class="text-left">ERF2</th>
                                    <th class="text-left">ERF3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>{{ formatNumber(diffLettureFooter.eaf1) }}</td>
                                    <td>{{ formatNumber(diffLettureFooter.eaf2) }}</td>
                                    <td>{{ formatNumber(diffLettureFooter.eaf3) }}</td>
                                    <td>{{ formatNumber(diffLettureFooter.erf1) }}</td>
                                    <td>{{ formatNumber(diffLettureFooter.erf2) }}</td>
                                    <td>{{ formatNumber(diffLettureFooter.erf3) }}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </template>

                    </DataTable>
                </div>
                <div v-else>
                    Nessun dato disponibile per il POD e la data selezionata.
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Card from 'primevue/card'
import FlussiOreService from "../../../services/ask-letture/flussi-ore-service.js"
import Loader from "@/components/Loader.vue"

const flussiOre = ref([]);
const loading = ref(false);
const rows = 50;
const totalRecords = ref(0);
const currentPage = ref(1);
const sortField = ref(null);
const sortOrder = ref(null);

const dataMisura = ref(null);
const dataMisuraConvertita = ref(null);

const letture = ref([]);

const searchPod = ref('');

const instance = getCurrentInstance();
const eventBus = instance.appContext.config.globalProperties.$eventBus;
const service = new FlussiOreService(eventBus);

const totaliFooter = ref({
    eaf1: 0,
    eaf2: 0,
    eaf3: 0,
    erf1: 0,
    erf2: 0,
    erf3: 0,
});

const diffLettureFooter = ref({
    eaf1: 0,
    eaf2: 0,
    eaf3: 0,
    erf1: 0,
    erf2: 0,
    erf3: 0,
});

const fetchData = async (page = 1, sortFieldValue = null, sortOrderValue = null) => {
    loading.value = true;
    try {
        const res = await service.getFlussiOre(page, rows, sortFieldValue, sortOrderValue);
        flussiOre.value = res.data ?? [];
        totalRecords.value = res?.total ?? 0;
        currentPage.value = res?.current_page ?? 1;
    } catch (error) {
        console.error("Errore nel caricamento dei flussi ore:", error);
        flussiOre.value = [];
    } finally {
        loading.value = false;
    }
};

const onPage = (event) => {
    const newPage = Math.floor(event.first / event.rows) + 1
    if (searchPod.value === '') {
        fetchData(newPage, sortField.value, sortOrder.value)
    } else {
        onSearch(newPage, sortField.value, sortOrder.value)
    }
}

const onSort = (event) => {
    sortField.value = event.sortField
    sortOrder.value = event.sortOrder
    if (searchPod.value === '') {
        fetchData(currentPage.value, sortField.value, sortOrder.value)
    } else {
        onSearch(currentPage.value, sortField.value, sortOrder.value)
    }
}

const formatNumber = (value) => {
  if (typeof value === 'number') {
    return value.toFixed(2)
  }
  if (!isNaN(value)) {
    return parseFloat(value).toFixed(2)
  }
  return value
}

const onSearch = async (page = 1, sortFieldValue = null, sortOrderValue = null) => {

    if (searchPod.value === '') {
        alert('Campo vuoto');
        return;
    }

    const podRegex = /^IT\d{3}[A-Z][A-Z0-9]{8}$/;
    if (!podRegex.test(searchPod.value.trim())) {
        alert('Formato POD non valido (es. IT001E12345678)');
        return;
    }

    if (dataMisura.value) {
        const year = dataMisura.value.getFullYear();
        const month = String(dataMisura.value.getMonth() + 1).padStart(2, '0');
        dataMisuraConvertita.value = `${year}-${month}`;

        const risposta = await service.getLettureConsumo(searchPod.value, dataMisuraConvertita.value);

        letture.value = [
            ...(risposta.consumo ? [risposta.consumo] : []),
            ...(risposta.lettura_corrente ? [risposta.lettura_corrente] : []),
            ...(risposta.lettura_precedente ? [risposta.lettura_precedente] : [])
        ];

        diffLettureFooter.value.eaf1 = risposta.eaf1
        diffLettureFooter.value.eaf2 = risposta.eaf2
        diffLettureFooter.value.eaf3 = risposta.eaf3

        diffLettureFooter.value.erf1 = risposta.erf1
        diffLettureFooter.value.erf2 = risposta.erf2
        diffLettureFooter.value.erf3 = risposta.erf3
    }

    loading.value = true;

    const ris = await service.searchPod(searchPod.value, dataMisuraConvertita.value, page, rows, sortFieldValue, sortOrderValue);
    flussiOre.value = ris.data ?? [];
    totalRecords.value = ris.total ?? 0;

    const somme = await service.getSommaFasce(searchPod.value, dataMisuraConvertita.value);
    totaliFooter.value.eaf1 = somme.eaf1;
    totaliFooter.value.eaf2 = somme.eaf2;
    totaliFooter.value.eaf3 = somme.eaf3;

    totaliFooter.value.erf1 = somme.erf1;
    totaliFooter.value.erf2 = somme.erf2;
    totaliFooter.value.erf3 = somme.erf3;

    loading.value = false;
}

</script>

<style scoped>

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th) {
    background: #495057 !important;
    color: #fff !important;
    border: none !important;
    padding: 1rem !important;
    font-weight: 600 !important;
    text-align: center !important;
    vertical-align: middle !important;
    font-family: 'Montserrat', sans-serif !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover) {
    background: #30656e !important;
    color: #fff !important;
    box-shadow: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover) {
    background: #30656e !important;
    color: #fff !important;
    box-shadow: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td) {
    padding: 0.8rem 1rem !important;
    border-bottom: 1px solid #dee2e6 !important;
    font-size: 0.9rem !important;
    text-align: center !important;
    vertical-align: middle !important;
    font-family: 'Montserrat', sans-serif !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
    text-align: left !important;
    padding-left: 1.2rem !important;
    font-weight: 500 !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child) {
    text-align: left !important;
    padding-left: 1.2rem !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:nth-child(even)) {
    background: #f8f9fa !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:hover) {
    background: #e9ecef !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-sortable-column-icon) {
    color: #fff !important;
    margin-left: 0.5rem !important;
    opacity: 1 !important;
    font-size: 0.9rem !important;
    display: inline-block !important;
    visibility: visible !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover .p-sortable-column-icon),
    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover .p-sortable-column-icon) {
    color: #fff !important;
    opacity: 1 !important;
    visibility: visible !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column) {
    cursor: pointer !important;
    user-select: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column .p-column-header-content) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child.p-sortable-column .p-column-header-content) {
    justify-content: flex-start !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-column-title) {
    color: #fff !important;
    font-weight: 600 !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:not(.p-sortable-column):hover),
    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:not(:hover)) {
    background: #495057 !important;
    color: #fff !important;
    }

</style>